export default __webpack_public_path__ + "static/media/landscape_logo.dbe40dc2.png";